module.exports = "/packs/images/svg/facilities/gift_shop~2f4a181fbbfce1f51184313e994c817e.svg";